<template>
    <popup-modal
        @close="$emit('close')"
        :title="$t('general.add_subject', {subject: $t('applications.documents')})"
        :close-on-click="!files.length"
        :description="$t('applications.documents_upload_description')"
        :loading="addingDocuments"
    >
        <div class="w-768">

            <file-upload v-model="files" type="document" multiple class="mb-32"></file-upload>

            <div class="flex justify-end">
                <simple-button
                    :disabled="!files.length"
                    display="secondary"
                    :loading="addingDocuments"
                    look="primary"
                    @click="addDocuments"
                >
                    {{ $t('general.add_subject', {subject: $t('applications.documents')}) }}
                </simple-button>
            </div>

        </div>
    </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue';
import FileUpload from '../forms/FileUpload.vue';
import SimpleButton from './SimpleButton.vue';
import * as documents from '../../services/DocumentService';
import Document from '../../models/Document';
import Application from '../../models/Application';
import { normalizeJson } from '../../../shared/helpers';
import {useRepo} from 'pinia-orm';

export default {
    components: {
        'popup-modal': PopupModal,
        'file-upload': FileUpload,
        'simple-button': SimpleButton
    },
    props: {
        application: {
            type: Application,
            required: true,
        }
    },
    data: function () {
        return {
            files: [],
            addingDocuments: false,
        }
    },
    methods: {
        addDocuments () {

            this.addingDocuments = true;

            let requests = [];

            this.files.forEach(file => {
                requests.push(
                    documents.store(this.application.id, {
                        data: {
                            attributes: { filename_queued_id: file },
                            relationships: { application: { data: { id: this.application.id }}}
                        }
                    }).then(result => {
                        return useRepo(Document).save(normalizeJson(result));
                    })
                );
            });

            Promise.all(requests).then(data => {
                this.addingDocuments = false;
                this.$emit('close');
            });
        }
    }
}
</script>
